import { useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import StickyButtons from './StickyButtons';
import CookieBanner from './CookieBanner';

export default function Layout() {
  const location = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [location.pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <Navbar />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <StickyButtons />
      <CookieBanner />
    </div>
  );
}
